import { Fragment, FunctionComponent, ReactNode } from "react";
import { Transition } from "@headlessui/react";

export interface SelectTransitionProps {
  children: ReactNode;
  afterLeave?: () => void;
}

/**
 * The transition when showing auto complete options
 */
export const SelectTransition: FunctionComponent<SelectTransitionProps> = ({
  afterLeave,
  children,
}) => {
  return (
    <Transition
      as={Fragment}
      leave="transition ease-in duration-100"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
      afterLeave={afterLeave}
    >
      {children}
    </Transition>
  );
};
